<!--页面部分-->
<template>
    <div class="LoginLog">
        <!--数据部分-->
        <div class="centerStructure">
            <!--检索条件-->
            <div class="searchBox">

                <span>关键字：</span>
                <el-input class="cname" v-model.trim="searchForm.searchWord" placeholder="账号、姓名" clearable></el-input>

                <span class="inp">登录IP：</span>
                <el-input class="cname" v-model.trim="searchForm.clientIp" placeholder="登录IP" clearable></el-input>

                <span class="inp">登录时间：</span>
                <el-date-picker
                        v-model="searchForm.dateValue"
                        value-format="timestamp"
                        type="datetimerange"
                        :default-time="['00:00:00','23:59:59']"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        size="small"
                >
                </el-date-picker>

                <el-button type="primary" @click="searchButton" icon="el-icon-search">查询</el-button>
            </div>
            <!--表格数据-->
            <el-table
                    :data="loginLogTableData"
                    border
                    ref="singleTable"
                    style="width: 100%"
                    height="calc(100% - 84px)">
                <el-table-column fixed header-align="center" type="index" align="center" width="50"></el-table-column>
                <template v-for="item in loginLogTableTitle">
                    <el-table-column
                            :align="item.align"
                            :header-align="item.halign"
                            :key="item.index"
                            :label="item.label"
                            :prop="item.prop"
                            :width="item.width"
                            :formatter="item.formatter"
                            v-if="item.prop !== 'operation'"
                            show-overflow-tooltip>
                    </el-table-column>
                </template>
            </el-table>
            <!--分页数据-->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNumber"
                    :page-sizes="[20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="pageTotal">
            </el-pagination>
        </div>
    </div>
</template>
<!--JS部分-->
<script>
    import {Mixins} from '@/config/mixins/mixins'
    import {$http} from '@/config/api/axios'
    import SearchDialog from '@/components/custom/Searchdialog'

    export default {
        name: "loginLog",
        mixins: [Mixins],  //混入公共方法,慎用.
        components: {
            SearchDialog,  //引入高级查询弹窗
        },

        data() {
            //时间戳转为年月日时分秒的格式
            function dateChange(value) {
                let date = new Date(parseInt(value.loginTime) * 1000);
                let Y = date.getFullYear() + '-';
                let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
                let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
                let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
                let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
                let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                return Y + M + D + h + m + s;
            }

            return {
                //检索条件
                searchForm: {
                    searchWord: '',//关键字
                    clientIp: '',  //客户端ip
                    startTime: '', //开始时间
                    endTime: '', //结束时间
                    dateValue: '',//日期控件值
                },
                //操作日志表格数据
                loginLogTableData: [],
                //操作日志表头
                loginLogTableTitle: [
                    {prop: "loginName", label: '登录账号', width: '120px', align: 'left', halign: 'center', show: true,},
                    {prop: "userName", label: '姓名', width: '200px', align: 'left', halign: 'center', show: true,},
                    {
                        prop: "loginTime",
                        label: '登录时间',
                        width: '160px',
                        align: 'center',
                        show: true,
                        'formatter': dateChange,
                    },
                    {prop: "loginIp", label: '登录IP', width: '150px', align: 'center', halign: 'center', show: true,},
                    {prop: "loginPort", label: '端口号', width: '120px', align: 'center', halign: 'center', show: true,},
                    {prop: "userAgent", label: '用户代理', width: '', align: 'left', halign: 'center', show: true,},

                ],
                //分页数据
                pageSize: 20, //条数
                pageNumber: 1,
                pageTotal: 0, //总页数
            }
        },

        //监听部分
        watch: {},
        //方法部分
        methods: {
            //查询按钮
            searchButton() {
                this.handleCurrentChange(1)
            },
            //查询操作日志列表
            getLoginLogList() {
                this.loginLogTableData = [];
                this.selfLoadingOpen('.LoginLog');
                let _this = this;
                if (_this.searchForm.dateValue !== "" && _this.searchForm.dateValue != null) {
                    _this.searchForm.startTime = Math.floor(_this.searchForm.dateValue[0] / 1000);
                    _this.searchForm.endTime = Math.ceil(_this.searchForm.dateValue[1] / 1000)
                } else {
                    _this.searchForm.startTime = null;
                    _this.searchForm.endTime = null;
                }
                let params = {};
                params.pageSize = _this.pageSize;
                params.pageNumber = _this.pageNumber;
                params.searchWord = _this.searchForm.searchWord;
                params.clientIp = _this.searchForm.clientIp;
                params.start = _this.searchForm.startTime;
                params.end = _this.searchForm.endTime;
                $http("get", "logForLogin/listLoginLog", params)
                    .then((res) => {
                            if (res.status === 'SUCCESS') {
                                for (let i = 0; i < res.data.length; i++) {
                                    this.loginLogTableData.push(res.data[i])
                                }
                                this.pageTotal = res.count;
                            } else if (res.status === 'NORESOURCES') {
                                this.loginLogTableData = [];
                                this.pageTotal = 0;
                            } else {
                                this.msgerror(res.message);
                        }
                        this.selfLoadingClose();
                    })
            },
            //切换页面方法
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleCurrentChange(1);
            },
            handleCurrentChange(val) {
                this.pageNumber = val;
                this.getLoginLogList();
            },
        },
        //初始化页面执行方法
        created: function () {
            this.getLoginLogList();    //初始化调用查询操作日志列表方法
        },
        activated() {
            if (!!this.$refs['singleTable']) {
                this.$refs.singleTable.doLayout();
            }
        },
    }
</script>
<!--css部分-->
<style lang="less">
    .LoginLog {
        width: 100%;
        height: 100%;
        margin-bottom: 10px;
        display: flex;
        .searchBox {
            .el-date-editor.el-range-editor {
                width: 355px;
            }
        }
    }
</style>